import { render } from "./InformacoesFinanceiras.vue?vue&type=template&id=1b7ba5f0&scoped=true&ts=true"
import script from "./InformacoesFinanceiras.vue?vue&type=script&lang=ts&setup=true"
export * from "./InformacoesFinanceiras.vue?vue&type=script&lang=ts&setup=true"

import "./InformacoesFinanceiras.vue?vue&type=style&index=0&id=1b7ba5f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7ba5f0"],['__file',"src/pages/home/components/InformacoesFinanceiras.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b7ba5f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b7ba5f0', __exports__)) {
    api.reload('1b7ba5f0', __exports__)
  }
  
  module.hot.accept("./InformacoesFinanceiras.vue?vue&type=template&id=1b7ba5f0&scoped=true&ts=true", () => {
    api.rerender('1b7ba5f0', render)
  })

}


export default __exports__